



























import Vue from "vue";
import { ElementColors } from "@/common/theme/ElementColors";

export default Vue.extend({
  name: "PPCollectOrderItem",
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
      Colors: ElementColors,
    };
  },
  methods: {},
});
